import { render, staticRenderFns } from "./BaseFieldTemplate.vue?vue&type=template&id=4dd1e8fc&scoped=true"
import script from "./BaseFieldTemplate.vue?vue&type=script&lang=js"
export * from "./BaseFieldTemplate.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldTemplate.vue?vue&type=style&index=0&id=4dd1e8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd1e8fc",
  null
  
)

export default component.exports